import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Link, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Button, Modal, ModalBody } from 'reactstrap'
const AsyncJobsModal = props => {
	const [modal, setModal] = useState(props.modal)
	const [jobData, setJobData] = useState(props.jobData)
	const [redirectUrl, setRedirectUrl] = useState('/tickets/job')
	const { t } = props
	useEffect(() => {
		if (props && props.jobData && props.jobData.requestId && props.jobData.requestId != jobData.requestId) {
			setModal(true)
			setJobData(props.jobData)
		}
		let url = window.location.href
		if (url.includes('/approvals')) {
			setRedirectUrl('/approvals/job')
		}
	}, [props])
	const toggleModal = () => {
		setModal(!modal)
		window.location.reload()
	}

	return (
		<div className="async-jobs-modal">
			<Modal autoFocus={false} isOpen={modal} backdrop="static" toggle={toggleModal} className="delete-card">
				<ModalBody>
					<Text>
						{t('Your request is in progress,')}{' '}
						<Link color="teal.500" href={redirectUrl} isExternal>
							{t('Click here')} : {jobData.requestId} <ExternalLinkIcon mx="2px" />
						</Link>{' '}
						{t('to check the status')}.
					</Text>
				</ModalBody>
				<div className="button-wrap">
					{' '}
					<Button color="secondary" onClick={toggleModal}>
						<img src={`assets/img/no.png`} alt="no" />
						{t('Close')}
					</Button>
				</div>
			</Modal>
		</div>
	)
}

export default withTranslation()(AsyncJobsModal)
